module.exports = __webpack_public_path__ + "img/dinosaur-apocalypse.b8e9bb66.jpg";